import React from 'react';

import classNames from './EABDStepIndicatorLabels.module.scss';

export interface StepIndicatorLabelsProps {
  readonly currentStepIndex: number;
  readonly getLabelForStepIndex: (stepIndex: number) => string;
  readonly style?: React.CSSProperties;
}

export const StepIndicatorLabels = React.memo<StepIndicatorLabelsProps>((props) => {
  const { currentStepIndex, getLabelForStepIndex, style } = props;

  const MovingContainer = React.useMemo(() => {
    const marginLeftBaseValue = currentStepIndex ? currentStepIndex - 1 : 0;

    const movingContainerStyle: React.CSSProperties = {
      marginLeft: `${marginLeftBaseValue * 10}%`,
    };

    const fullLabel = getLabelForStepIndex(currentStepIndex);
    const fullLabelWithSeparatedByLineBreaks = fullLabel.split('\n');

    return (
      <div className={classNames.moving} style={movingContainerStyle}>
        <div className={classNames.textWrapper}>
          <p className={classNames.text}>
            {fullLabelWithSeparatedByLineBreaks.map((line: string, index: number) => {
              if (index !== fullLabelWithSeparatedByLineBreaks.length - 1) {
                return (
                  <React.Fragment key={index}>
                    {line}
                    <br></br>
                  </React.Fragment>
                );
              }

              return <React.Fragment key={index}>{line}</React.Fragment>;
            })}
          </p>
        </div>
      </div>
    );
  }, [currentStepIndex, getLabelForStepIndex]);

  return (
    <div className={classNames.container} style={style}>
      {MovingContainer}
    </div>
  );
});
